module.exports = __webpack_public_path__ + "static/media/plus-circle.025ac0e2.svg";